/**
 * Route table for the dashboard SPA.
 *
 * Public:    /login, /signup, /forgot-password, /reset-password, /verify-email
 * Protected: everything under <ProtectedRoute> (rendered inside <AppLayout>).
 *
 * Implements the full MVP flow:
 *   login → list apps → edit config → subscribe (Stripe) → build → poll → download
 */
import { Navigate, Route, Routes } from 'react-router-dom';
import { ProtectedRoute } from './auth/ProtectedRoute';
import { AppLayout } from './components/AppLayout';
import { LoginPage } from './pages/Login';
import { SignupPage } from './pages/Signup';
import { ForgotPasswordPage } from './pages/ForgotPassword';
import { ResetPasswordPage } from './pages/ResetPassword';
import { VerifyEmailPage } from './pages/VerifyEmail';
import { HandoffPage } from './pages/Handoff';
import { AppsListPage } from './pages/AppsList';
import { AppEditorPage } from './pages/AppEditor';
import { BuildPanelPage } from './pages/BuildPanel';
import { AccountPage } from './pages/Account';
import { AdminTemplateRequestsPage } from './pages/AdminTemplateRequests';

export function App(): JSX.Element {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route path="/signup" element={<SignupPage />} />
      <Route path="/forgot-password" element={<ForgotPasswordPage />} />
      <Route path="/reset-password" element={<ResetPasswordPage />} />
      <Route path="/verify-email" element={<VerifyEmailPage />} />
      <Route path="/handoff" element={<HandoffPage />} />
      <Route path="/admin/templates" element={<AdminTemplateRequestsPage />} />

      <Route element={<ProtectedRoute />}>
        <Route element={<AppLayout />}>
          <Route path="/" element={<Navigate to="/apps" replace />} />
          <Route path="/apps" element={<AppsListPage />} />
          <Route path="/apps/:appId" element={<AppEditorPage />} />
          <Route path="/apps/:appId/build" element={<BuildPanelPage />} />
          <Route path="/account" element={<AccountPage />} />
        </Route>
      </Route>

      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
